(function () {
  function slugify(text) {
    const base = text
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/gi, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
    return base || 'section';
  }

  function ensureHeadingIds(headings) {
    const used = new Set();
    headings.forEach((heading, index) => {
      let id = heading.id && heading.id.trim();
      if (id) {
        used.add(id);
        return;
      }
      let base = slugify(heading.textContent || '') + '-' + (index + 1);
      while (used.has(base) || document.getElementById(base)) {
        base = slugify(heading.textContent || '') + '-' + index + '-' + Math.random().toString(36).slice(2, 7);
      }
      heading.id = base;
      used.add(base);
    });
  }

  function getScrollMargin() {
    const root = document.documentElement;
    const h = parseFloat(getComputedStyle(root).getPropertyValue('--header-height')) || 0;
    return h + 24;
  }

  function updateActiveHeading(headings, links) {
    const offset = getScrollMargin();
    const line = offset + 8;
    let active = null;
    for (const h of headings) {
      const rect = h.getBoundingClientRect();
      if (rect.top <= line) active = h;
    }
    if (!active && headings.length) active = headings[0];

    links.forEach((a) => {
      const href = a.getAttribute('href') || '';
      const linkId = href.startsWith('#') ? href.slice(1) : '';
      const on = active && linkId === active.id;
      a.classList.toggle('is-active', !!on);
      if (on) {
        a.setAttribute('aria-current', 'location');
      } else {
        a.removeAttribute('aria-current');
      }
    });
  }

  function initOne(bodyEl) {
    if (bodyEl.dataset.articleTocInitialized === 'true') return;
    if (typeof bodyEl._articleTocAbort === 'function') {
      bodyEl._articleTocAbort();
      bodyEl._articleTocAbort = null;
    }
    const layout = bodyEl.closest('.article-template__toc-layout');
    if (!layout) return;

    const articleRoot = layout.closest('.article-template');
    const nav = layout.querySelector('.article-template__toc--desktop');
    const listDesktop = layout.querySelector('[data-article-toc-list-desktop]');
    const mobileRoot = articleRoot ? articleRoot.querySelector('[data-article-toc-mobile]') : null;
    const listMobile = mobileRoot ? mobileRoot.querySelector('[data-article-toc-list-mobile]') : null;
    const lists = [listDesktop, listMobile].filter(Boolean);

    if (!nav || !listDesktop) return;

    lists.forEach((ul) => {
      ul.innerHTML = '';
    });

    const headings = Array.from(bodyEl.querySelectorAll('h1, h2, h3, h4'));
    if (!headings.length) {
      nav.remove();
      if (mobileRoot) {
        mobileRoot.hidden = true;
      }
      layout.classList.add('article-template__toc-layout--no-toc');
      bodyEl.dataset.articleTocInitialized = 'true';
      return;
    }

    bodyEl.dataset.articleTocInitialized = 'true';
    ensureHeadingIds(headings);

    const links = [];

    headings.forEach((heading) => {
      lists.forEach((list) => {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.className = 'article-template__toc-link link';
        a.href = '#' + heading.id;
        a.textContent = heading.textContent.trim();
        a.addEventListener('click', (e) => {
          e.preventDefault();
          heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
          if (history.replaceState) {
            history.replaceState(null, '', '#' + heading.id);
          }
          heading.setAttribute('tabindex', '-1');
          heading.focus({ preventScroll: true });
          const details = a.closest('details');
          if (details) {
            details.removeAttribute('open');
          }
        });
        li.appendChild(a);
        list.appendChild(li);
        links.push(a);
      });
    });

    nav.hidden = false;
    if (mobileRoot) {
      mobileRoot.hidden = false;
    }

    const run = () => updateActiveHeading(headings, links);
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        ticking = false;
        run();
      });
    };

    const ac = new AbortController();
    window.addEventListener('scroll', onScroll, { passive: true, signal: ac.signal });
    window.addEventListener('resize', onScroll, { passive: true, signal: ac.signal });
    bodyEl._articleTocAbort = () => ac.abort();
    run();
  }

  function initArticleToc() {
    document.querySelectorAll('[data-article-body]').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initArticleToc);
  } else {
    initArticleToc();
  }

  document.addEventListener('shopify:section:load', (e) => {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-article-body]')) {
      e.target.querySelectorAll('[data-article-body]').forEach((el) => {
        if (typeof el._articleTocAbort === 'function') {
          el._articleTocAbort();
          el._articleTocAbort = null;
        }
        delete el.dataset.articleTocInitialized;
      });
      initArticleToc();
    }
  });
})();
